{
  binList: {
    buttonLabels: {
      deleteItemsWithConnectedContent: "Eliminar elemento(s)",
      deleteSelected: "Eliminar selección",
      emptyBin: "Papelera vacía",
      restoreItems: "Restaurar elemento|Restaurar elementos",
      restoreSelected: "Restaurar selección",
    },
    confirmToDeleteAllItems: "¿Desea realmente eliminar 1 contenido y los contenidos asociados? | ¿Desea realmente eliminar todos los {count} contenidos y los contenidos asociados?",
    confirmToDeleteSelectedItems: "¿Desea realmente eliminar 1 contenido seleccionado y los contenidos asociados? | ¿Desea realmente eliminar los {count} contenidos seleccionados y los contenidos asociados?",
    confirmToRestoreSelectedItems: "¿Seguro que quieres restaurar el elemento seleccionado?|¿Seguro que quieres restaurar los {count} elementos seleccionados?",
    missingManageAccess: "No tienes los permisos necesarios para uno o varios elementos seleccionados o relacionados.",
    modalTitles: {
      deleteItems: "Eliminar elementos",
      emptyBin: "Papelera vacía",
      restoreItems: "Restaurar elementos",
    },
    moduleDescription: "Restaura o elimina de forma permanente tus etiquetas, formularios, citas y contenidos de la mediateca eliminados.",
    moduleTitle: "Papelera",
    permanentDeleteWarning: "Este contenido se eliminará de forma irreversible y se eliminará permanentemente de las estadísticas y de los historiales de cualificación. No es posible la recuperación. Por favor, compruebe si la opción de archivar sería una alternativa adecuada.",
    restoreFailed: "No se han podido restaurar los elementos. Vuelve a intentarlo más tarde.",
    restoreSuccessful: "El elemento se ha restaurado correctamente.|Los elementos se han restaurado correctamente.",
    tags: "Etiquetas",
    title: "Título",
    type: "Tipo",
    typeSelectLabel: "Tipos",
  },
  categories: {
    categorySelectLabelPlural: "Categorías",
    categorySelectLabelSingular: "Categoría",
  },
  contentCategories: {
    addCategory: "Añadir categoría",
    categoryHasRelatedCourses: "1 curso relacionado | {count} cursos relacionados",
    categoryHasRelatedForms: "1 formulario relacionado | {count} formularios relacionados",
    categoryHasRelatedKeywords: "1 palabra clave relacionada | {count} palabras clave relacionadas",
    categoryHasRelatedTags: "1 etiqueta relacionada | {count} etiquetas relacionadas",
    contentCategoryCreatedSuccessfully: "Categoría creada correctamente",
    contentCategoryPutInBinSuccessfully: "La categoría se ha movido a la papelera.",
    contentCategorySelect: {
      add: "Añadir",
      defaultLabel: "Categoría",
      nameLabel: "Nombre de la nueva categoría",
      newCategory: "Nueva categoría",
    },
    contentCategoryUpdatedSuccessfully: "Categoría actualizada correctamente",
    createCategory: "Crear categoría",
    deleteCategoryConfirmation: "¿Seguro que quieres poner esta categoría en la papelera?",
    deleteCategoryTitle: "Eliminar categoría",
    general: "General",
    name: "Nombre",
    newCategory: "Nueva categoría",
    saveChanges: "Guardar cambios",
    types: {
      "1300": "Palabras clave",
      "19": "Formularios",
      "20": "Citas",
      "3000": "Etiquetas",
      "5": "Cursos",
    },
  },
  course: {
    chapter_deleted_successfully: "El capítulo se ha eliminado correctamente.",
    content_deleted_successfully: "El contenido se ha eliminado correctamente.",
    contents: {
      completion_time: "⌀ de tiempo de finalización",
      completion_time_tooltip: "Cuánto tardaron de media los usuarios en terminar este contenido desde que empezaron el curso.",
      forms: {
        all: "Todo",
        answers: "Respuestas",
        completion_duration: "Duración de finalización",
        download: "Descargar",
        filters: "Filtros",
        last_worked_on: "Fecha de la última edición",
        not_submitted: "No presentado",
        search: "Buscar",
        star_answer: "1 estrella|{count} estrellas",
        stars: "Estrellas",
        started_at: "Empezado el",
        submitted: "Presentado",
        user: "Usuario",
      },
      passed: "Aprobado",
      passed_tooltip: "Cuántos usuarios han aprobado este contenido.",
      questions: {
        all: "Todo",
        answer: "Respuesta",
        answerCorrect: "Respuesta correcta",
        categoryResults: "Resultados por categoría",
        completion_time: "Tiempo de finalización",
        download: "Descargar",
        failed: "Suspendido",
        filters: "Filtros",
        is_correct: "¿Es correcto?",
        last_worked_on: "Fecha de la última edición",
        passed: "Aprobado",
        percentage: "Porcentaje",
        questions_count: "1 pregunta | {count} preguntas",
        remind_users: "Recordar a los usuarios",
        search: "Buscar",
        started_at: "Empezado el",
        status: "Estado",
        tries: "Intentos",
        unfinished: "Sin terminar",
        user: "Usuario",
      },
      remind_users: "Recordar a los usuarios",
      score: "⌀ de puntuación",
      score_tooltip: "Para exámenes: Qué porcentaje de preguntas respondieron correctamente los usuarios de media.",
      search: "Buscar",
      show_contents_with_statistics: "Mostrar solo contenido con estadísticas",
      time_spent_here: "⌀ de tiempo pasado aquí",
      title: "Título",
      todolists: {
        passed: "Terminado",
        started: "Empezado",
        user: "Usuario",
      },
      tries: "⌀ de intentos",
      tries_tooltip: "Para exámenes: Cuántos intentos necesitaron los usuarios de media para aprobar este examen.",
      type: "Tipo",
    },
    participants: {
      active: "Activo",
      all: "Todos los participantes + usuarios con acceso",
      archived: "Archivado",
      certificate_n: "Certificado {n}",
      certificates: "Certificados",
      completion_time: "Tiempo de finalización",
      completion_time_tooltip: "La duración entre el inicio y la finalización del curso.",
      displaySettings: "Configuración de visualización",
      download: "Descargar",
      download_column: "Descargar",
      download_column_tooltip: "Si el usuario recibió certificados como parte del curso, se pueden descargar aquí.",
      expired: "Expirado",
      failed: "Solo participantes suspendidos",
      filters: "Filtros",
      finished: "Solo participantes terminados",
      includeInactiveUsers: "Incluir usuarios inactivos",
      last_worked_on: "Fecha de la última edición",
      last_worked_on_tooltip: "Hora a la que el usuario avanzó por última vez en el curso",
      mark_participation_as_passed: "Marcar curso como aprobado para este usuario",
      metafieldColumnLabel: "Metacampo: {label}",
      metafieldFilter: "Filtro {metafield}",
      metafieldSettings: "Columnas de metacampos",
      participating: "Solo participantes",
      progress: "Progreso",
      remind_users: "Recordar a los usuarios",
      remind_users_successfully: "El recordatorio se ha enviado correctamente al usuario seleccionado.|Los recordatorios se han enviado correctamente a los usuarios seleccionados.",
      reset_participation_status: "Restablecer el estado del curso y no puntuar el último intento de examen suspendido",
      reset_progress: "Restablecer el progreso del curso",
      reset_progress_confirm: "Restablecer el progreso",
      reset_progress_confirmation: "¿Seguro? Esto eliminará permanentemente el progreso del curso y revocará todos los certificados obtenidos. Para formaciones recurrentes, recomendamos encarecidamente usar {courseTemplateLink} en su lugar.",
      reset_progress_confirmation_course_templates_link: "plantillas de curso",
      reset_progress_confirmation_with_completion_tag_actions: "Eliminación correcta. Ten en cuenta que los TAGs que el usuario haya obtenido o perdido al completar este curso no se restablecen automáticamente. Debes eliminarlos o asignarlos manualmente si es necesario.",
      search: "Buscar",
      showProgress: "Mostrar progreso",
      started_at: "Empezado el",
      started_at_tooltip: "Hora a la que el usuario empezó el curso",
      status: "Estado",
      status_tooltip: "El estado actual del curso de este usuario",
      statuses: {
        failed: "Suspendido",
        notPassedAt: "Suspendido el {0}",
        notPassedYet: "Aún no aprobado",
        notStarted: "No empezado",
        passed: "Aprobado",
        passed_at: "Aprobado el {0}",
        started: "Empezado",
      },
      unfinished_participants: "Solo participantes no finalizados",
      unfinished_users: "Todos los usuarios no finalizados",
      user: "Usuario",
      usertags: "Etiquetas de usuario",
    },
    removers: {
      chapter: {
        confirmPermanentDeletion: "¿Quieres eliminar este capítulo de forma permanente?",
        contents: "1 contenido del curso|{count} contenidos del curso",
        deleteChapter: "Eliminar capítulo",
        lastChapterCantBeDeleted: "El último capítulo de un curso no se puede eliminar.",
      },
      content: {
        certificates: "1 certificado concedido|{count} certificados concedidos",
        confirmPermanentDeletion: "¿Quieres eliminar este contenido de forma permanente?",
        deleteContent: "Eliminar contenido",
      },
    },
    settings: {
      access: "Acceso",
      accessManagement: "Gestión de accesos",
      accessTypeOptions: {
        tagAssignment: "Asignación de etiquetas",
        userAssignment: "Asignación de usuarios",
      },
      active: "Activo",
      addNotification: "Añadir notificación",
      additionalRecipients: "Destinatarios adicionales",
      additionalRecipientsHint: "Correos electrónicos separados por comas",
      availableFrom: "Inicio del curso",
      availableUntil: "Fin del curso",
      awardTags: "Asignar estas etiquetas después de aprobar el curso",
      canNavigateFreely: "Permitir la navegación libre en el curso",
      dateHint: "Formato: dd.mm.aaaa",
      daysBeforeCourseEnds: "Días antes de que finalice el curso",
      description: "Añadir una descripción para este curso",
      duration: "Limitación de tiempo",
      durationDynamicText: "Configura cuánto tiempo deben tener los usuarios después de empezar el curso.",
      durationOptions: {
        dynamic: "Tiempo límite basado en el inicio de la participación",
        fixed: "Fecha de inicio y fin",
      },
      enablePreview: "Habilitar la vista previa del curso",
      enablePreviewText: "Permite a los usuarios que no tienen acceso al curso solicitar el acceso al mismo.",
      endDateAlert: "Si asignas una fecha de fin al curso, puedes configurar aquí las notificaciones que se enviarán a los usuarios y administradores.",
      escalationManagement: "Gestión del desarrollo",
      finished: "Terminado",
      firstCourseCreation: "Creación del primer curso",
      howLongText: "Configura cuántas veces debe crearse el curso y cuánto tiempo deben tener los usuarios para terminar cada curso.",
      howOftenText: "Configura con qué frecuencia debe crearse un curso a partir de esta plantilla.",
      inactive: "Inactivo",
      intervalTypeOptions: {
        monthly: "Meses",
        weekly: "Semanas",
      },
      intervalTypeOptionsInline: {
        monthly: "mes|meses",
        weekly: "semana|semanas",
      },
      isMandatory: "Curso obligatorio",
      managers: "Responsables",
      name: "Nombre del curso",
      notifyManagers: "Notificar a los responsables del curso y a las personas externas antes de que termine el curso",
      notifyUsers: "Notificar a los usuarios antes de que termine el curso",
      participationDuration: "Tiempo de finalización",
      participationDurationType: {
        days: "Días",
        months: "Meses",
        weeks: "Semanas",
      },
      passed: "Aprobado",
      reminderTerm: "{count} día antes | {count} días antes",
      repeatedCourseNameAlert: "Los cursos creados a partir de esta plantilla se llamarán «{name} (semana/año actuales)».",
      repeating: "Tipo de plantilla",
      repeatingTypeOptions: {
        nonRepeating: "No recurrente",
        repeating: "Recurrente",
      },
      repetitionAlert: {
        availableNewCourse: "Los nuevos cursos estarán disponibles durante {timeLimit} {timeLimitType}.",
        latestCourseCreatedAt: "El último curso se creó el {date}.",
        learnMore: "Más información",
        limitedRepetitionText: "Luego se creará 1 curso más después de {repetitionInterval} {repetitionIntervalType}.|Luego se crearán {count} cursos más después de {repetitionInterval} {repetitionIntervalType}.",
        nextRepetitionCourseDate: "El siguiente curso se creará el {date}.",
        repetitionCountAchievedText: "Este curso ya se ha creado una vez. Por lo tanto, ya no se creará automáticamente un nuevo curso. | Este curso ya se ha creado {count} veces. Por lo tanto, ya no se creará automáticamente un nuevo curso.",
        unlimitedRepetitionText: "Después se creará un nuevo curso cada {repetitionInterval} {repetitionIntervalType}.",
      },
      repetitionCount: "Número de repeticiones",
      repetitionInterval: "Repetir cada",
      requestAccessLink: "Redirigir URL",
      retractTags: "Eliminar estas etiquetas después de aprobar el curso",
      sections: {
        CourseRepetition: {
          title: "Creación automática de cursos regulares",
        },
        access: {
          title: "Acceso",
        },
        actionsAfterPassing: {
          description: "Configura actualizaciones automáticas de las etiquetas después de que un usuario haya aprobado este curso.",
          title: "Acciones después de aprobar el curso",
        },
        description: {
          title: "Descripción",
        },
        duration: {
          title: "Duración del curso",
        },
        escalationManagement: {
          title: "Gestión del desarrollo",
        },
        general: {
          title: "General",
        },
        managers: {
          description: "Selecciona los responsables del curso a los que se notificará la actividad del curso.",
          title: "Responsables del curso",
        },
        notifications: {
          description: "Configura las notificaciones que se enviarán automáticamente cuando se produzcan determinados eventos.",
          title: "Notificaciones",
        },
        templateInheritance: {
          description: "Haz que esta plantilla esté disponible para otras aplicaciones.",
          title: "Herencia de plantillas",
        },
      },
      sendNewCourseNotification: "Informar a los usuarios cuando empiece el curso",
      sendNewCourseNotificationTooltip: "Este ajuste solo se puede cambiar para los cursos con fecha de inicio futura.",
      sendPassedCourseMail: "Enviar un correo electrónico de confirmación a los usuarios después de aprobar el curso",
      sendRepetitionCourseReminder: "Enviar un recordatorio a los responsables de los cursos antes de crear un curso a partir de esta plantilla",
      showRequestAccessLink: "URL personalizada para solicitudes de acceso",
      showRequestAccessLinkText: "En lugar de informar a los responsables del curso sobre las solicitudes de acceso, remite a los usuarios a una URL específica cuando soliciten acceso.",
      templateInheritance: {
        courseIsNotAvailable: "Este curso no está disponible en {language}.",
      },
      templateName: "Nombre de la plantilla",
      timeLimit: "Límite de tiempo",
      timeLimitType: {
        months: "Meses",
        weeks: "Semanas",
      },
      timeLimitTypeInline: {
        months: "mes|meses",
        weeks: "semana|semanas",
      },
      timeUnit: "Unidad de tiempo",
      unlimited: "Sin límites",
      users: "Usuarios",
    },
    wbtResults: {
      duration: "Tiempo invertido según WBT",
      durationInMinutes: "Tiempo invertido según WBT (minutos)",
      last_worked_on: "Fecha de la última edición",
      status: "Estado",
      user: "Usuario",
    },
  },
  courseTemplates: {
    appCategories: "Categorías de aplicaciones propias",
    appTemplates: "Plantillas de aplicaciones propias",
    breadcrumbs: {
      courseTemplates: "Plantillas de cursos",
      courses: "Cursos",
    },
    extendedCategories: "Biblioteca ampliada",
    featured: "Dónde figura",
    filters: {
      active: "Activo",
      all: "Todo",
      archived: "Archivado",
      inactive: "Inactivo",
      isNotRepeating: "No recurrente",
      isRepeating: "Recurrente",
    },
    inheritedAppTemplates: "{appName} plantillas",
    inheritedTemplateCategories: "{appName} categorías",
    keeunitCategories: "Biblioteca estándar",
    keeunitTemplates: "Plantillas de keelearning",
    lessons: "Lecciones",
    loadCourseTemplate: "Cargar curso",
    preview: "Vista previa",
    showDetails: "Mostrar detalles",
    startWithEmptyCourse: "Empezar con un curso vacío",
    templates: "1 plantilla | {count} plantillas",
    types: {
      appTemplate: "Plantilla propia",
      course: "Curso",
      template: "plantilla",
    },
  },
  courses: {
    add_course: "Añadir curso",
    bin: {
      relatedItems: {
        certificates: "1 certificado | {count} certificados",
        commentReports: "1 informe de comentarios | {count} informes de comentarios",
        comments: "1 comentario | {count} comentarios",
        contents: "1 contenido | {count} contenidos",
        participations: "1 participación | {count} participaciones",
        tests: "1 examen | {count} exámenes",
      },
    },
    breadcrumbs: {
      contents: "Contenido",
      settings: "Ajustes",
    },
    categories: "Categorías",
    category: "Categoría",
    contentCategories: {
      description: "Crea, traduce y gestiona aquí tus categorías de cursos.",
      title: "Categorías de cursos",
    },
    contentTemplates: {
      description: "Crea y gestiona aquí tus plantillas de cursos.",
      title: "Plantillas de cursos",
    },
    contents: {
      addTagRestriction: "Añadir restricción de etiquetas",
      certificate: {
        name: "Nombre del certificado",
        title: "Certificado",
      },
      commentModuleMustBeActivatedInAllAppProfiles: "La función de carga sólo puede utilizarse con el módulo de comentarios activado en todos los perfiles de aplicación (tenants).",
      enforceFileUpload: "Forzar la carga de archivos",
      enforceFileUploadHint: "Los usuarios tienen que cargar al menos un archivo para terminar esta lista de tareas pendientes.",
      title: "Título del contenido",
      todoList: {
        addTask: "Añadir tarea",
        description: "Información adicional",
        removeTodoConfirmation: "¿Seguro que quieres quitar esta lista de tareas pendientes?",
        removeTodoTitle: "Quitar lista de tareas pendientes",
        tasksHeader: "Tareas",
        title: "Tarea",
      },
    },
    courseContentN: "Contenido {n}",
    coursePreview: "Vista previa del curso",
    createTemplate: "Crear plantilla",
    filters: {
      name: "Nombre/ID",
    },
    globalListHeaders: {
      allUsersCount: "Inscrito",
      availableFrom: "Inicio del curso",
      completed: "Completado",
      createdAt: "Fecha de creación",
      isRepeating: "Es recurrente",
      mandatory: "Obligatorio",
      name: "Nombre",
      nextRepetitionDate: "Próxima fecha de repetición",
      published: "Publicado",
      repeatsEvery: "Se repite cada",
      statistics: "Estadísticas",
      user: "Usuario",
    },
    manageCategories: "Gestionar categorías",
    manageTemplates: "Gestionar plantillas",
    moduleDescription: "Combinar contenido en cursos.",
    moduleTitle: "Cursos",
    remover: {
      contentExists: "Este contenido sigue enlazado en el curso: «{courseTitle}», «{courseChapterTitle}», «{courseContentTitle}». {link}",
    },
    repetitions: {
      everyMonth: "Cada mes",
      everyNMonths: "Cada {frequency} meses",
      everyNWeeks: "Cada {frequency} semanas",
      everyWeek: "Cada semana",
    },
    settings: {
      actions: {
        archive: "Archivar",
        duplicate: "Duplicar",
        preview: "Vista previa",
        saveAsTemplate: "Guardar como plantilla",
        unarchive: "Desarchivar",
      },
      archiveConfirmation: "¿Quieres archivar el curso existente? <br /><br />\nEl curso se cancelará automáticamente para todos los participantes activos. <br />\nLas estadísticas se mantendrán. <br /><br />",
      archiveCourse: "Archivar curso",
      archivedSuccessfully: "Curso archivado correctamente",
      courseAlreadyTemplate: "El curso ya está marcado como plantilla.",
      deleteConfirmation: "¿Está seguro/a de que desea mover el curso « {courseName} » a la papelera?",
      deleteCourse: "Eliminar curso",
      deletedSuccessfully: "El curso se ha movido a la papelera.",
      duplicatedSuccessfully: "Curso duplicado correctamente",
      saveAsTemplate: "Guardar curso como plantilla",
      saveAsTemplateConfirmation: "¿Seguro que quieres guardar este curso como plantilla?",
      savePublishedCourseShouldContainActiveContent: "El curso necesita al menos un contenido publicado para que se pueda publicar.",
      savePublishedCourseShouldContainContent: "El curso necesita al menos un contenido para poder publicarse.",
      savePublishedTemplateShouldContainActiveContent: "La plantilla necesita al menos un contenido publicado para que se pueda publicar.",
      savePublishedTemplateShouldContainContent: "La plantilla necesita al menos un contenido para poder publicarse.",
      savedAsTemplateSuccessfully: "Curso guardado como plantilla correctamente",
      unarchivedSuccessfully: "Curso desarchivado correctamente",
      unsavedChangesWarning: "Guarda el curso primero.",
    },
    title: "Cursos",
  },
  createApp: {
    buttonLabels: {
      submitButton: "Crear aplicación",
    },
    dataSaveFailure: "No se han podido guardar los datos.",
    dataSaveSuccess: "La aplicación se ha creado correctamente. Preparar el contenido inicial tarda unos minutos.",
    fieldLabels: {
      defaultLanguage: "Idioma predeterminado",
      hubspotCompany: "Empresa HubSpot",
      name: "Nombre de la aplicación",
      slug: "ID de la aplicación",
      subdomain: "Subdominio de la aplicación",
    },
    hubspotLoadingFailure: "No se han podido cargar las empresas HubSpot.",
    title: "Crear aplicación",
  },
  fileUploads: {
    corruptFileDetected: "Asegúrate de que el archivo no procede de dentro de un archivo .zip y de que no está dañado.",
    deleteFile: "Se ha producido un error durante la eliminación.",
    dragAndDropOr: "Arrastrar y soltar o",
    fileInformationUnavailable: "Información del archivo no disponible",
    fileLoadError: "Se ha producido un error durante la carga.",
    fileTypeUnsupported: "Este tipo de archivo no es compatible.",
    invalidFile: "Archivo no válido seleccionado",
    loading: "Cargando",
    or: "o",
    selectFile: "Seleccionar archivo",
    uploadCancelled: "Carga cancelada",
    uploadCancelledError: "Se ha producido un error durante la cancelación.",
    uploadFailed: "Se ha producido un error durante la carga.",
    waitForFileInformation: "Espera la información del archivo.",
  },
  forms: {
    categories: "Categorías",
    contentCategories: {
      description: "Crea, traduce y gestiona aquí tus categorías de formularios.",
      title: "Categorías de formularios",
    },
    create: "Crear formulario",
    formDeleting: {
      confirmation: "¿Seguro que quieres mover este formulario «{formName}» a la papelera?",
      deletedSuccessFully: "El formulario se ha movido a la papelera.",
      title: "Eliminar formulario",
    },
    formDetailsPage: {
      actions: "Acciones",
      addFieldButtonLabel: "Añadir campo",
      addFieldModal: {
        title: "Añadir campo de formulario",
      },
      alerts: {
        isArchived: "Este formulario está archivado.",
        isBinned: "Este formulario está en la papelera.",
      },
      archiveForm: "Archivar formulario",
      archivedSuccessFully: "El formulario se ha archivado.",
      createdAt: "Fecha de creación",
      createdSuccessfully: "El formulario se ha creado correctamente.",
      deleteForm: "Eliminar formulario",
      duplicateForm: "Duplicar formulario",
      duplicatedSuccessFully: "El formulario se ha duplicado.",
      fields: {
        "1": {
          description: "Los usuarios responden a tu pregunta por escrito.",
          name: "Pregunta de texto libre",
        },
        "2": {
          description: "Los usuarios pueden responder a tu pregunta con una puntuación de 0 a 5 estrellas.",
          name: "Puntuación con estrellas",
        },
        "3": {
          description: "Te permite añadir un título a tu formulario o a sus subapartados.",
          name: "Encabezamiento",
        },
        "4": {
          description: "Marca un nuevo apartado.",
          name: "Separador",
        },
      },
      isRequired: "Obligatorio",
      module: "Módulo",
      name: "Nombre",
      publishForm: "Publicar formulario",
      removers: {
        field: {
          confirmPermanentDeletion: "¿Quieres eliminar este campo de forma permanente?",
          deleteField: "Eliminar campo",
        },
      },
      replies: "Respuestas",
      saveChanges: "Guardar cambios",
      search: "Buscar",
      sections: {
        fields: {
          description: "Añade campos al formulario y ordénalos arrastrándolos y soltándolos.",
          title: "Campos de formulario",
        },
        form: {
          title: "Formulario",
        },
        publishing: {
          description: "Los formularios publicados se pueden añadir a los cursos.",
          title: "Publicación",
        },
        usage: {
          description: "Esta tabla muestra los cursos que utilizan este formulario.",
          title: "Uso",
        },
      },
      subPages: {
        general: "General",
        usage: "Uso ({count})",
      },
      title: "Título",
      unarchiveForm: "Desarchivar formulario",
      unarchivedSuccessFully: "El formulario se ha desarchivado.",
      updatedAt: "Fecha de actualización",
    },
    formList: {
      description: "Crea y gestiona formularios que se puedan incrustar en los cursos.",
      filter: "Filtro",
      filterLabels: {
        active: "Visible/en curso",
        archived: "Archivado",
        name: "Nombre/ID",
      },
      table: {
        category: "Categoría",
        tags: "Etiquetas",
        title: "Formulario",
        updatedAt: "Fecha de actualización",
      },
      title: "Formularios",
    },
    noFormFields: "Añade campos a este formulario para utilizarlo en un curso.",
    title: "Formularios",
  },
  global: {
    action: "Acción",
    addCoverImage: "Añadir imagen de portada",
    allUsers: "Todos los usuar",
    all_types: "Todos los tipos",
    appProfiles: "Perfiles de aplicación",
    cancel: "Cancelar",
    characters: "Un carácter|{count} caracteres",
    close: "Cerrar",
    columnVisibility: {
      allColumnsHiddenWarning: "Al menos una columna debe permanecer visible.",
      alwaysVisible: "Esta columna debe permanecer visible.",
      cancel: "Cancelar",
      confirm: "Confirmar",
      description: "Elige qué columnas son visibles en esta tabla. Puedes cambiar estos ajustes en cualquier momento.",
      loadFailure: "No se ha podido cargar la configuración de visibilidad de columnas.",
      missingColumn: "La visibilidad de columnas está incompleta.",
      reset: "Restablecer valores predeterminados",
      title: "Configurar tabla",
      unknownColumn: "Columna desconocida.",
    },
    confirmRemove: "Sí, quitar",
    create: "Crear",
    creationDate: "Fecha de creación",
    dataSaveFailure: "No se han podido guardar los datos.",
    dateHint: "Formato: aaaa-mm-dd",
    delete: "Eliminar",
    deleteIrreversibly: "Eliminar de forma irreversible",
    deletionDate: "Fecha de eliminación",
    editedAt: "Fecha de edición",
    info: "Información",
    languages: {
      al: "Albanés",
      ar: "Árabe",
      bg: "Búlgaro",
      cs: "Checo",
      de: "Alemán (informal)",
      de_formal: "Alemán (formal)",
      en: "Inglés",
      es: "Español",
      fr: "Francés",
      hr: "Croata",
      hu: "Húngaro",
      it: "Italiano",
      jp: "Japonés",
      nl: "Neerlandés",
      no: "Noruego",
      pl: "Polaco",
      pt: "Portugués",
      ro: "Rumano",
      ru: "Ruso",
      sr: "Serbio",
      tr: "Turco",
      uk: "Ucraniano",
      vi: "Vietnamita",
      zh: "Chino",
    },
    manageTranslations: "Gestionar traducciones",
    maxCharacters: "Máx. {count} caracteres",
    morphTypes: {
      "1": "Archivo de la mediateca | Archivos de la mediateca",
      "10": "Pregunta | Preguntas",
      "1000": "Capítulo | Capítulos",
      "1001": "Contenido del curso de preguntas | Contenidos del curso de preguntas",
      "1003": "Contenido del curso | Contenidos del curso",
      "1005": "Premio de cursos | Premios de cursos",
      "1008": "Texto | Textos",
      "1009": "Contenido del curso de preguntas | Contenidos del curso de preguntas",
      "11": "Respuesta | Respuestas",
      "1100": "Tarea | Tareas",
      "12": "Carpeta de la mediateca | Carpetas de la mediateca",
      "1200": "Plantilla de correo electrónico | Plantillas de correo electrónico",
      "13": "Categoría de preguntas | Categorías de preguntas",
      "1300": "Palabra clave | Palabras clave",
      "14": "Grupo de categorías | Grupos de categorías",
      "1400": "Vale | Vales",
      "15": "Batalla de quiz | Batallas de quiz",
      "1500": "Seminario web | Seminarios web",
      "16": "Aplicación | Aplicaciones",
      "1600": "Premio de exámenes | Premios de exámenes",
      "17": "Comentario | Comentarios",
      "1700": "Informe | Informes",
      "18": "Pregunta sugerida | Preguntas sugeridas",
      "19": "Formulario | Formularios",
      "2": "Noticias",
      "20": "Cita | Citas",
      "2000": "Usuario",
      "21": "Lista de tareas | Listas de tareas",
      "22": "Página | Páginas",
      "23": "Campo de formulario | Campos de formulario",
      "24": "Báner | Báneres",
      "25": "Categoría de contenido | Categorías de contenido",
      "26": "Archivo adjunto a la pregunta | Archivos adjuntos a la pregunta",
      "3": "Concurso de quiz | Concursos de quiz",
      "3000": "Etiqueta",
      "3001": "Grupo de etiquetas",
      "4": "Certificado | Certificados",
      "40": "Respuesta | Respuestas",
      "4000": "Comunidad | Comunidades",
      "4002": "Tenant | Tenants",
      "5": "Curso | Cursos",
      "6": "Examen | Exámenes",
      "7": "Pregunta de examen | Preguntas de examen",
    },
    noResultMatchSearch: "No se han encontrado resultados que coincidan con tu búsqueda.",
    notificationTrackedSinceMessage: "(Las notificaciones se rastrean desde enero de 2024).",
    preview: "Vista previa",
    proceed: "Proceder",
    publish: "Publicar",
    publishStatus: {
      completed: "Completado",
      expired: "Expirado",
      on: "el {date}",
      unpublished: "Sin publicar",
      visible: "Visible",
    },
    save: "Guardar",
    search: "Buscar",
    searchIcon: "Buscar icono",
    select: "Seleccionar",
    selectApp: "Seleccionar aplicación",
    settings: "Ajustes",
    showDetails: "Mostrar detalles",
    startedDate: "Empezado el",
    tag: "Etiqueta",
    tags: "Etiquetas",
    user: {
      email: "Correo electrónico",
      first_name: "Nombre",
      last_name: "Apellidos",
    },
    warning: "Advertencia",
    willAlsoDeleteFollowingData: "También se eliminarán los datos siguientes:",
  },
  kEntityImage: {
    label: "Imagen",
  },
  kTable: {
    noResults: "No se ha encontrado ningún contenido con los criterios de búsqueda especificados. Puedes ajustar los filtros de arriba para ver los resultados.",
    noResultsWithNotAllowedEntries: "No se ha encontrado ningún contenido. Puede haber otros resultados a los que no tengas acceso.",
  },
  kdetailPage: {
    backToOverview: "Volver a la lista",
    discardChangesAlert: "Aún tienes cambios sin guardar. \n¿Quieres descartar los cambios?",
    unsavedChangesWarnings: {
      discardChanges: "Descartar cambios",
      discardUnsavedChanges: "¿Quieres descartar los cambios no guardados?",
      title: "Cambios no guardados",
    },
  },
  mediaLibrary: {
    add_content: "Añadir contenido",
    all_types: "Todos los tipos",
    cant_add_file_in_root: "No se pueden añadir archivos a la carpeta raíz.",
    cant_delete_folder_has_folders_files: "Primero elimina todas las carpetas y los archivos de esta carpeta. {link}",
    choose_new_folder: "Elegir una nueva carpeta",
    delete_folder_confirmation: "¿Seguro que quieres poner la carpeta «{folderName}» y todo su contenido en la papelera?",
    delete_folder_title: "Eliminar carpeta de la mediateca",
    duplicateFolder: "Duplicar carpeta",
    duplicatedSuccessFully: "La carpeta se ha duplicado.",
    files: {
      access: "Acceso",
      add_cover_image: "Añadir imagen de portada",
      cant_delete_has_course_contents: "Primero elimina todos los contenidos del curso vinculados a este archivo. {link}",
      comments: "Comentarios",
      date: "Fecha",
      delete_file_confirmation: "¿Seguro que quieres poner el archivo «{fileName}» en la papelera?",
      delete_file_title: "Eliminar archivo de la mediateca",
      description: "Descripción",
      details: "Detalles",
      duplicateFile: "Duplicar archivo",
      duplicatedSuccessFully: "El archivo se ha duplicado.",
      file_path: "Ruta del archivo",
      general: "General",
      media_file_created_successfully: "El archivo se ha creado correctamente.",
      media_file_deleted_successfully: "El archivo se ha movido a la papelera.",
      media_file_saved_successfully: "El archivo se ha guardado correctamente.",
      move_file: "Mover archivo",
      notificationNoResult: "Ningún usuario ha recibido aún ninguna notificación para este archivo.",
      pastNotifications: "Notificaciones anteriores",
      past_notifications: "Notificaciones anteriores",
      processing: "Este archivo se está procesando actualmente.",
      processingFailed: "El procesamiento del archivo ha fallado.",
      publish_file: "Publicar archivo en la mediateca",
      publish_on_specific_date: "Debe publicarse en una fecha concreta.",
      published_at: "Fecha de publicación",
      publishing: "Publicar en la mediateca",
      publishing_note: "Decide si el archivo debe publicarse en la mediateca de inmediato o en una fecha específica. El contenido también es visible en el curso, incluso si no está publicado.",
      reminder_notifications: "Recordatorio y notificación",
      reminder_notifications_note: "Notificaciones para cuando el archivo sea visible",
      select_file_type: "Selecciona un tipo de archivo",
      sendNotification: "Enviar notificación cuando se publique el {publishedAt}",
      sendNotifications: {
        allUsers: {
          button: "Notificar al usuario | Notificar a los {count} usuarios",
          text: "Ningún usuario tiene acceso actualmente a este archivo ni quiere ser notificado. | Enviar una notificación al usuario que actualmente tiene acceso a este archivo y quiere ser notificado. | Enviar una notificación a los {count} usuarios que actualmente tienen acceso a este archivo y quieren ser notificados.",
          title: "Todos los usuarios",
        },
        header: "Enviar notificación",
        onlyNewUsers: {
          button: "Notificar al usuario nuevo | Notificar a los {count} usuarios nuevos",
          text: "Todos los usuarios que actualmente tienen acceso a este archivo ya han recibido una notificación o no quieren ser notificados. | Enviar una notificación al usuario que aún no ha recibido una notificación para este archivo y quiere ser notificado. | Enviar una notificación a los {count} usuarios que aún no han recibido una notificación para este archivo, pero quieren ser notificados.",
          title: "Solo usuarios nuevos",
        },
        sentSuccessFully: "Ahora se enviarán las notificaciones.",
      },
      sendNotificationsButtonLabel: "Enviar notificación a todos los usuarios o a los nuevos",
      sendNotificationsWithUnsavedChangesMessage: "Guarda los cambios antes de enviar las notificaciones.",
      send_notification_at_published_on: "Enviar notificación cuando se publique el",
      send_notification_to_all_new_users: "Enviar notificación a todos los usuarios o a los nuevos",
      usage: "Uso ({count})",
      usage_note: "Esta tabla muestra todos los usos de este archivo fuera de la mediateca.",
      usage_title: "Uso",
      users: "Usuarios",
      users_with_access: "Usuarios con acceso",
      videoAnalytics: "Análisis de vídeo",
      videoAnalyticsNote: "Esta tabla muestra durante cuánto tiempo han reproducido el vídeo los usuarios.",
    },
    likes: "Me gusta",
    media_folder_deleted_successfully: "La carpeta se ha movido a la papelera.",
    media_library_file: "Archivo",
    media_library_folder: "Carpeta",
    media_library_listing_note: "Archivos guardados en la aplicación",
    media_library_listing_title: "Mediateca",
    module: "Módulo",
    move: "Mover",
    move_folder: "Mover carpeta",
    name: "Nombre",
    new_file: "Nuevo archivo",
    new_folder: "Nueva carpeta",
    notificationNoResult: "Ningún usuario ha recibido aún ninguna notificación para este archivo.",
    path: "Ruta",
    save_changes: "Guardar cambios",
    search: "Buscar",
    search_by_name_description: "Nombre/descripción",
    search_folder: "Buscar carpeta",
    suggestAIQuestions: {
      creatingAIQuestionsNotAvailable: "La creación de preguntas con IA no está disponible para este archivo.",
      creatingKnowledgeCheckNotAvailable: "La creación de un control de conocimiento no está disponible para este archivo.",
      disabledGeneratingAIQuestionsMessage: "Actualmente, las preguntas con IA solo están disponibles para los PDF o si se da una descripción de más de 50 caracteres.",
      errorGeneratingQuestions: "Se ha producido un error al crear las sugerencias de preguntas.\nVuelve a intentarlo más tarde o carga otro archivo.",
      generateAIQuestionsFeatureDisabled: "Para utilizar esta función, debes activar «Creación de preguntas con IA en la mediateca» en Ajustes → Opciones.",
      generatingAIQuestionsWithUnsavedChangesMessage: "Guarda los cambios antes de generar las preguntas.",
      generatingQuestions: "<b>Se están generando sugerencias de preguntas.</b></br>Este proceso dura hasta tres minutos.",
      goToSuggestedQuestions: "Ir a las preguntas sugeridas",
      helpdeskLinkAriaLabel: "Abrir el artículo de ayuda sobre las sugerencias de preguntas con IA",
      questionsGeneratedSuccessfully: "Se ha generado 1 sugerencia de pregunta. | Se han generado {count} sugerencias de preguntas.",
      reachedMaximumTimesOfAIQuestionsGeneration: "Tu plan solo te permite crear preguntas con IA a partir de {count} archivos al mes como máximo. Para crear más preguntas con IA, ponte en contacto con nuestro equipo de éxito del cliente por correo electrónico {email}.",
      successGeneratingQuestions: "Seleccione las preguntas que desea utilizar. Puede editarlas y publicarlas más tarde.",
      title: "Sugerir preguntas con IA",
    },
    title: "Título",
    views: "Visualizaciones",
    wbtHelpText: "Eche un vistazo a los WBT que apoyamos",
  },
  notifications: {
    history: {
      sentAt: "Fecha de envío",
      users: "Usuarios",
    },
  },
  pagination: {
    entriesPerPage: "Entradas por página:",
    of: "de",
    page: "Página:",
  },
  question: {
    labelModal: {
      description: "Haz clic en la imagen para añadir etiquetas.",
      title: "Etiquetado de imágenes",
    },
  },
  sessionReplay: {
    defaultDescription: "Informe de error sin descripción.",
    descriptionFailed: "No se pudo enviar tu informe de error. Inténtalo de nuevo.",
    descriptionLabel: "Descripción",
    descriptionPlaceholder: "¿Qué ocurrió y qué esperabas que ocurriera?",
    descriptionSent: "Informe de error enviado. Gracias por ayudarnos a mejorar la aplicación. Investigaremos el problema y te contactaremos por correo electrónico cuando tengamos novedades.",
    explanation: "Tu grabación se ha detenido. Describe qué salió mal y qué esperabas que ocurriera. Tu descripción se vinculará a la grabación.",
    finished: "Enviar informe de error",
    sendDescription: "Enviar informe de error",
    sendingDescription: "Enviando…",
    start: "Informar de un problema técnico",
    startFailed: "No se pudo iniciar la grabación. Inténtalo de nuevo.",
    startRecording: "Iniciar grabación",
    startedInstructions: "<p>Selecciona «<strong>Iniciar grabación</strong>» para iniciar la grabación y repite los pasos que causaron el problema.</p><p>Tus interacciones en esta aplicación se grabarán para ayudarnos a entender lo ocurrido.</p><p>Cuando termines, selecciona «<strong>Detener grabación</strong>». Después podrás añadir una descripción y enviar tu informe de error a nuestro equipo de soporte.</p>",
    stop: "Detener grabación",
    stopFailed: "No se pudo detener la grabación. Inténtalo de nuevo.",
    unavailable: "La grabación no está disponible en este momento. Inténtalo más tarde.",
  },
  sidenavigation: {
    accounts: "Cuentas",
    advertisements: "Báneres",
    app: "Aplicación",
    appointments: "Citas",
    bin: "Papelera",
    certificateTemplates: "Plantillas de certificados",
    comments: "Comentarios",
    communities: "Comunidades",
    contents: "Contenido",
    course: "Cursos",
    courseLibrary: "Biblioteca del curso",
    courseTemplates: "Plantillas de curso",
    courses: "Cursos",
    coursesOverview: "Visión general del curso",
    cronJobs: "Tareas Cron",
    dashboard: "Panel de control",
    emailTemplate: "Plantillas de correo electrónico",
    forms: "Formularios",
    import: "Importar",
    integrationCenter: "Centro de Integración",
    keywords: "Palabras clave",
    learningMaterials: "Mediateca",
    metafields: "Metacampos",
    news: "Noticias",
    oldCronJobs: "Tareas Cron antiguas",
    pages: "Páginas",
    powerlearning: "Powerlearning",
    publicApiTokens: "Tokens de API públicos",
    questionCategory: "Categorías de preguntas",
    questions: "Preguntas",
    quizBattle: "Batalla de quiz",
    quizCompetitions: "Concursos de quiz",
    quizTeams: "Equipos de quiz",
    reviews: "Reseñas",
    roles: "Roles",
    settings: "Ajustes",
    statistics: "Estadísticas",
    tagGroups: "Grupos de etiquetas",
    tags: "Etiquetas",
    tenants: "Tenants",
    tests: "Exámenes",
    translationRules: "Reglas de traducción",
    translations: "Editar y traducir",
    user: "Usuario",
    userActivity: "Actividad de los usuarios",
    userSubmittedQuestions: "Preguntas enviadas",
    views: "Visualizaciones",
    vouchers: "Vale",
    wbtStatistics: "Estadísticas de WBT",
    webinars: "Seminarios web",
  },
  statistics: {
    course_has_low_finishing_percentage_card_content: "Solo un {percentage} % de los usuarios han terminado el curso {link}, que finaliza en {daysUntilEnd} días el {availableUntil}.",
    course_participations: "Participaciones en cursos",
    courses: {
      active_courses: "Cursos activos",
      all_users: "Todos los usuarios",
      archived: "Archivado",
      avg_time_to_finish_description: "Tiempo medio transcurrido entre que un usuario empieza el curso y lo finaliza",
      breadcrumbs: {
        courses: "Cursos",
        participants: "Participantes en el curso",
        statistics: "Análisis",
      },
      content_irregular_time_description: "Los usuarios invierten {content_duration} de media en {title}, pero solo {other_contents_avg_time} de media en otros contenidos.",
      courseViewsTrackedSince: "Los accesos al curso se empezaron a registrar el {trackingStartDate}.",
      course_duration: "Duración del curso",
      course_dynamic_ends: "El curso finaliza {duration} después de que un usuario lo haya empezado.",
      course_ended_on: "El curso terminó el {date}.",
      course_ends_on: "El curso termina el {date}.",
      course_started_on: "El curso empezó el <b>{date}</b>.",
      course_starts_on: "El curso empieza el <b>{date}</b>.",
      course_views_count: "Este curso se vio 1 vez.|Este curso se vio {count} veces.",
      courses_currently_visible: "Actualmente no hay cursos disponibles.|curso está disponible actualmente.|cursos están disponibles actualmente.",
      courses_currently_visible_for_selected_users: "Actualmente no hay cursos disponibles para los usuarios seleccionados.|curso está disponible actualmente para los usuarios seleccionados.|cursos están disponibles actualmente para los usuarios seleccionados.",
      editCourse: "Editar curso",
      global_list_filters: {
        active: "Activo",
        active_mandatory: "Activo y obligatorio",
        all: "Todo",
        archived: "Archivado",
        current: "Activo y en preparación",
        expired: "Expirado",
        in_preparation: "En preparación",
      },
      global_list_headers: {
        all_users: "Todos los usuarios",
        all_users_tooltip: "Usuarios activos con acceso o participación anterior en el curso",
        avg_completion_time: "⌀ de tiempo de finalización",
        avg_completion_time_excel: "⌀ de tiempo de finalización (minutos)",
        avg_completion_time_tooltip: "El tiempo medio transcurrido desde el inicio hasta la finalización del curso",
        comments: "Comentarios",
        passed: "Aprobado",
        passed_tooltip: "Usuarios que han aprobado el curso en comparación con todos los usuarios",
        started: "Empezado",
        started_tooltip: "Usuarios que han empezado el curso en comparación con todos los usuarios",
        title: "Título",
        users_with_access: "Usuarios con acceso",
        users_with_access_tooltip: "Usuarios activos con acceso al curso",
      },
      inactive: "Inactivo",
      navigation: {
        comments: "Comentarios",
        contents: "Contenido",
        course: "Curso",
        overview: "Resumen",
        participants: "Participantes",
      },
      new_course: "Nuevo curso",
      new_participants: "Nuevos participantes",
      new_participants_over_time: "Nuevos participantes a lo largo del tiempo",
      notExist: "El curso no existe.",
      participants: "Participantes",
      participants_avg_time_finish: "Tiempo medio de finalización",
      participation_duration_type: {
        "0": "1 día|{count} días",
        "1": "1 semana|{count} semanas",
        "2": "1 mes|{count} meses",
      },
      participation_status: {
        finished: "Terminado",
        not_started: "No empezado",
        started: "En curso",
      },
      pass_rate: "Porcentaje de aprobados",
      periodRanges: {
        last30Days: "Últimos 30 días",
        last7Days: "Últimos 7 días",
        lastYear: "El año pasado",
      },
      templates: "Plantillas",
      viewcount: "Visualizaciones",
      wbtVerbs: {
        "http://adlnet": {
          "gov/expapi/verbs/attempted": "Empezado",
          "gov/expapi/verbs/completed": "Completado",
          "gov/expapi/verbs/experienced": "Empezado",
          "gov/expapi/verbs/failed": "Suspendido",
          "gov/expapi/verbs/passed": "Aprobado",
        },
      },
    },
    finished_courses: "Cursos activos terminados",
    finished_courses_tooltip: "Cuando todos los usuarios hayan terminado todos sus cursos actualmente activos, esto será 100 %.",
    in_the_last3Days: "en los últimos 3 días",
    in_the_last7Days: "en los últimos 7 días",
    last30Days: "Últimos 30 días",
    last7Days: "Últimos 7 días",
    mandatory_content_finished: "Contenido obligatorio activo finalizado",
    mandatory_content_finished_tooltip: "Cuando todos los usuarios hayan terminado todo su contenido obligatorio actualmente activo, esto será 100 %.",
    minutes: "minutos",
    most_commented_course_card_content: "El curso {link} recibió {comments_count} comentarios {period}.",
    most_liked_course_card_content: "El curso {link} recibió {likes_count} «me gusta» {period}.",
    nDays: "1 día|{count} días",
    nHours: "1 hora|{count} horas",
    nMinutes: "1 minuto|{count} minutos",
    nSeconds: "1 segundo|{count} segundos",
    previousLast30Days: "Últimos 30 días anteriores",
    previousLast7Days: "Últimos 7 días anteriores",
    seconds: "segundos",
    time_range: "Intervalo de tiempo",
    today: "Hoy",
    view_comments: "Ver comentarios",
    yesterday: "Ayer",
  },
  tagGroups: {
    add_tag: "Añadir etiqueta",
    cant_delete_has_tags: "Primero elimina todas las etiquetas de este grupo de etiquetas. {link}",
    color: "Color",
    count_tags_in_group: "Hay 1 etiqueta en este grupo.|Hay {count} etiquetas en este grupo.",
    create_tag_group: "Crear grupo de etiquetas ",
    delete_tag_group: "Eliminar grupo de etiquetas",
    delete_tag_group_confirmation: "¿Seguro que quieres poner el grupo de etiquetas «{tagGroup}» y todas sus etiquetas en la papelera?",
    delete_tag_group_title: "Eliminar grupo de etiquetas",
    description: "Aquí puedes gestionar los grupos de etiquetas y las etiquetas asociadas.",
    edit_color_icon: "Editar color e icono",
    general: "General",
    icon: "Icono",
    name: "Nombre",
    new_tag_group: "Nuevo grupo de etiquetas ",
    no_tag_groups_yet: "Aún no se ha añadido ningún grupo de etiquetas.",
    no_tags_in_tag_group: "Aún no se ha añadido ninguna etiqueta a este grupo de etiquetas.",
    save_changes: "Guardar cambios",
    search_for_tag: "Buscar etiqueta",
    signup_required: "Se debe seleccionar durante el registro.",
    signup_selectable: "El usuario lo puede seleccionar durante el registro.",
    tag_group_created_successfully: "Grupo de etiquetas creado correctamente",
    tag_group_deleted_successfully: "El grupo de etiquetas se ha movido a la papelera.",
    tag_group_updated_successfully: "Grupo de etiquetas actualizado correctamente",
    title: "Etiquetas",
  },
  tagSelect: {
    label: "Etiquetas",
  },
  tags: {
    all_types: "Todos los tipos",
    can_not_delete_tag_with_usage_count: "No se puede eliminar la etiqueta «{label}», tiene {count} usos. {link}",
    created_at: "Fecha de creación",
    delete_tag: "Eliminar etiqueta",
    delete_tag_confirmation: "¿Seguro que quieres mover esta etiqueta a la papelera?",
    delete_tag_title: "Eliminar etiqueta",
    edit_tag_group: "Reasignar grupo de etiquetas",
    edited_at: "Fecha de edición",
    exclusive_label: "Permitir batallas de quiz solo con esta etiqueta",
    general: "General",
    hideHighscore_label: "Excluir usuarios con esta etiqueta de las estadísticas del quiz",
    module: "Módulo",
    save_changes: "Guardar cambios",
    search: "Buscar",
    tagIsBinned: "Esta etiqueta está en la papelera.",
    tag_created_successfully: "Etiqueta creada correctamente",
    tag_deleted_successfully: "La etiqueta se ha movido a la papelera.",
    tag_group: "Grupo de etiquetas",
    tag_settings: "Ajustes de etiquetas",
    title: "Título",
    usage: "Uso | Uso ({count})",
    usage_note: "Esta tabla muestra a todos los usuarios y todos los contenidos que utilizan esta etiqueta.",
    usage_title: "Uso",
  },
  tenants: {
    administrators: "Administradores",
    create_tenant: "Crear tenant",
    create_tenant_btn: "Crear tenant",
    created_at: "Fecha de creación",
    general: "General",
    main_app: "Aplicación principal",
    main_app_admin: "Añade a un usuario existente como administrador de la aplicación principal. Los administradores de la aplicación principal solo están restringidos por su rol, pero pueden ver todo el contenido y a todos los usuarios de los módulos correspondientes.",
    main_app_description: "Los usuarios no asignados a un tenant se asignan automáticamente a esta aplicación principal.",
    module_description: "Aquí puedes gestionar a tus tenants. Los tenants tienen sus propios ajustes y pueden tener sus propios administradores.",
    name: "Nombre",
    new_tenant_headline: "Nuevo tenant",
    open_settings: "Abrir ajustes",
    promote_admin: "Ascender a administrador",
    save_changes: "Guardar cambios",
    settings: "Ajustes",
    settings_description: "Cada tenant tiene ajustes individuales. Define tus propios ajustes de diseño, visibilidad de los módulos, etc.",
    tag: "Etiqueta",
    tag_description: "El contenido con esta etiqueta está asignado a este tenant.",
    tenant_admin: "Añade a un usuario existente como administrador de este tenant. A continuación, este administrador puede gestionar automáticamente solo los usuarios y contenidos de este tenant.",
    tenant_created_successfully: "El tenant se ha creado correctamente. Continúa con sus ajustes.",
    title: "Tenants",
    user_admin: "El usuario ha sido configurado como administrador para «{name}».",
    users: "Usuarios",
  },
  topNavigation: {
    appSwitcher: "App Switcher",
    greetings: "Hola, {username}",
    guide: "Guía",
    help: "Ayuda",
    helpdesk: "Servicio de asistencia",
    logout: "Cerrar sesión",
    newCourse: "Nuevo curso",
    openApp: "Abrir aplicación",
    privacyPolicy: "Política de privacidad",
    telephoneSupport: "Asistencia telefónica: {telephoneNumber}",
  },
  translations: {
    advertisement: {
      description: "Contenido",
      leaderboardImageUrl: "Gráfico (escritorio)",
      link: "Enlace",
      rectangleImageUrl: "Gráfico (móvil)",
    },
    appointment: {
      coverImageUrl: "Imagen de portada",
      description: "Descripción",
      name: "Nombre",
    },
    autoTranslateHumanTranslations: "Sobrescribe también los textos introducidos manualmente con la traducción automática.",
    autoTranslateMessage: "Traducir todos los campos a {language} (beta)",
    automaticTranslate: "Traducir {defaultLanguage} automáticamente (beta)",
    autotranslateRunning: "Traducción automática en curso de 1 contenido.|Traducción automática en curso de {count} contenidos.",
    azureVideoPreview: {
      awaitingProcessing: "Esperando procesamiento",
      isProcessing: "Procesando... \nEsto puede tardar un poco. \nPuedes salir de esta página y volver más tarde.",
      processingCanceled: "Se ha interrumpido el procesamiento.",
      processingComplete: "Procesamiento finalizado",
      processingError: "Error durante el procesamiento",
      processingIsBeingCanceled: "Se está cancelando el procesamiento.",
      processingIsBeingStarted: "Ha empezado el procesamiento.",
      videoStatus: "Vídeo:",
    },
    bulkAutoTranslateButtonLabel: "Traducir automáticamente",
    category: {
      coverimage: "Imagen de portada",
      name: "Nombre",
    },
    categoryGroup: {
      name: "Nombre",
    },
    certificate: {
      image: "Imagen",
    },
    changesNotTranslatedYet: "Los cambios aún no se han traducido. \nÚltimos cambios:",
    communities: {
      coverimage: "Imagen de portada",
      description: "Descripción",
      name: "Nombre",
    },
    confirmAutoTranslate: "Confirmar traducción",
    contentCategory: {
      name: "Nombre",
    },
    copyContentFromDefaultLanguage: "Copiar contenido desde {defaultLanguage}",
    countElementsTranslatedManually: "1 traducción ha sido introducida o ajustada manualmente por última vez por un administrador. ¿Quieres sobrescribir esta entrada con la traducción automática?|{count} traducciones han sido introducidas o ajustadas manualmente por última vez por un administrador. ¿Quieres sobrescribir estos textos con la traducción automática?",
    course: {
      chapter: {
        content: {
          description: "Descripción",
          title: "Título",
        },
        title: "Título",
      },
      coverimage: "Imagen de portada",
      description: "Descripción",
      requestAccessLink: "Enlace a la solicitud de acceso",
      text: {
        content: "Contenido",
        content_back: "Contenido (reverso)",
        headline: "Título",
        hotspots: "Hotspots",
        image: "Imagen",
        image_back: "Imagen (reverso)",
      },
      title: "Título",
    },
    dataSaveFailure: "No se han podido guardar los datos.",
    downloadAllowed: "Permitir descarga",
    editLabels: "Editar etiquetas",
    exportHelpText: "Exporta todos los contenidos de texto filtrados actualmente para su traducción/revisión.",
    exportSelectedHelpText: "Exporta todos los contenidos de texto seleccionados actualmente para su traducción/revisión.",
    form: {
      coverImageUrl: "Imagen de portada",
      title: "Título",
    },
    formfield: {
      title: "Título",
    },
    hereYouCanTranslateAllContent: "Aquí puedes traducir todo el contenido. También puedes exportar e importar los contenidos.",
    import: {
      importError: "La importación no se ha realizado correctamente. Asegúrate de haber seleccionado el archivo correcto.",
      importSuccess: "El archivo se ha importado correctamente.",
    },
    importHelpText: "Importar un archivo exportado previamente desde esta página",
    keyword: {
      description: "Descripción",
      name: "Nombre",
    },
    labelPlaceholder: "Etiqueta",
    mailTemplate: {
      body: "Correo electrónico",
      title: "Asunto",
    },
    medialibrary: {
      coverimage: "Imagen de portada",
      description: "Descripción",
      file: "Archivo",
      name: "Nombre",
    },
    medialibraryFolder: {
      name: "Nombre",
    },
    missingTranslationsCount: {
      contentCount: "1 contenido|{count} de estos contenidos",
      message: "{0} aún no se ha traducido completamente al idioma seleccionado.|{0} aún no se han traducido completamente al idioma seleccionado.",
    },
    mustBeValidLink: "Tiene que empezar por http(s)://",
    mustBeValidYoutubeUrl: "Tiene que ser una URL de YouTube válida.",
    news: {
      content: "Contenido",
      coverimage: "Imagen de portada",
      title: "Título",
    },
    page: {
      content: "Contenido",
      title: "Título",
    },
    primaryLanguage: "Idioma principal",
    question: {
      title: "Título",
    },
    questionanswer: {
      answer: "Respuesta",
      feedback: "Feedback",
    },
    questioncloze: {
      answer: "Respuesta",
      correct: "Correcta",
      feedback: "Feedback",
      placeholders: "Comodines",
    },
    saveAndClose: "Guardar y cerrar",
    saveAndNext: "Guardar y siguiente",
    saveContent: "Guardar",
    saveToEditLabels: "Guarda la traducción antes de editar las etiquetas.",
    scormWBTMessage: "Actualmente no recopilamos estadísticas de la formación basada en web en formato SCORM. Al integrar el WBT SCORM en un curso, puedes acceder al éxito del alumno a través de las estadísticas del curso.<br /> Si quieres hacer un seguimiento de los eventos dentro de tu WBT, cárgalo en el formato moderno xAPI.",
    selectEntriesFromTheTable: "Seleccionar entradas de la tabla",
    selectFileType: "Selecciona el tipo de archivo.",
    startAutoTranslateButton: "No traducir ninguna entrada|Traducir 1 entrada|Traducir {count} entradas",
    statusOptions: {
      all: "Todo",
      notTranslated: "No traducido",
      translated: "Traducido",
    },
    subtileProcessingError: "Subtítulo: error durante la generación. Ponte en contacto con el servicio técnico.",
    subtitleHint: "Elige el idioma del vídeo.",
    subtitleLabel: "Subtítulo",
    subtitleProcessing: "Subtítulo:",
    tableHeaderAll: "Todo",
    tableHeaderLastUpdated: "Último cambio",
    tableHeaderStatus: "Estado",
    tableHeaderTitle: "Título",
    tableHeaderTranslate: "Traducir",
    tableHeaderType: "Tipo",
    test: {
      description: "Descripción",
      name: "Nombre",
    },
    title: "Editar y traducir",
    toOriginalContent: "Abrir contenido original",
    todolistitem: {
      description: "Descripción",
      title: "Título",
    },
    totalElementsToAutoTranslate: "Se ha seleccionado 1 entrada en total para la traducción.|Se han seleccionado {count} entradas en total para la traducción.",
    translationStatus: "Estado de la traducción",
    translationTitle: "Título",
    translationsStatus: {
      automaticTranslationRunning: "Traducción automática en curso",
      dependenciesMissing: "Algunos contenidos no se han traducido",
      missing: "No traducido",
      ok: "Completamente traducido",
    },
    typeOptions: {
      advertisement: "Báneres",
      appointment: "Citas",
      category: "Categorías",
      categoryGroup: "Categorías de preguntas",
      certificateTemplate: "Plantillas de certificados",
      communities: "Comunidades",
      contentCategory: "Categorías de contenido",
      course: "Cursos",
      courseAward: "Premios del curso",
      courseChapter: "Capítulos del curso",
      courseContent: "Contenido del curso",
      emailTemplate: "Plantillas de correo electrónico",
      form: "Formularios",
      keyword: "Palabras clave",
      medialibraryFile: "Archivos de la mediateca",
      medialibraryFolder: "Carpetas de la mediateca",
      news: "Noticias",
      page: "Páginas",
      questions: "Preguntas",
      reporting: "Informes",
      tag: "Etiquetas",
      tagGroup: "Grupos de etiquetas",
      test: "Exámenes",
      user: "Usuarios",
      voucher: "Vales",
      webinar: "Seminarios web",
    },
    typeSelectLabel: "Tipos",
    unsavedChanges: "Hay cambios sin guardar.",
    updated: "Actualizada",
    videoProcessingError: "Vídeo: error en el procesamiento. Ponte en contacto con el servicio técnico.",
    videoSaveHint: "Guarda el contenido para empezar a procesar el vídeo.",
    wbtType: "Tipo de WBT",
  },
  users: {
    userSelect: {
      defaultLabel: "Usuario",
      noUserFound: "No se ha encontrado ningún usuario.",
      searchHint: "Buscar por nombre de usuario/correo electrónico",
    },
  },
  validation: {
    accepted: "{attribute} debe ser aceptado.",
    accepted_if: "{attribute} debe ser aceptado cuando {other} tiene el valor {value}.",
    active_url: "{attribute} no es una URL válida.",
    after: "{attribute} debe ser una fecha posterior a {date}.",
    after_or_equal: "{attribute} debe ser una fecha posterior o igual a {date}.",
    alpha: "{attribute} solo puede contener letras.",
    alpha_dash: "{attribute} solo puede contener letras, números y guiones.",
    alpha_num: "{attribute} solo puede contener letras y números.",
    array: "{attribute} debe ser una lista.",
    attributes: {
      content: "Contenido",
      email: "Correo electrónico",
      name: "Nombre",
      password: "Contraseña",
      password_confirmation: "Confirmación de contraseña",
      remember: "Recordar credenciales",
      tag_ids: "Etiquetas",
      text_content: "El texto",
    },
    available_from_is_before_available_until: "La fecha de inicio no puede ser posterior a la fecha de finalización.",
    before: "{attribute} debe ser una fecha anterior a {date}.",
    before_or_equal: "{attribute} debe ser una fecha anterior o igual a {date}.",
    between: {
      array: "{attribute} debe tener entre {min} y {max} elementos.",
      file: "{attribute} debe tener entre {min} y {max} kilobytes.",
      numeric: "{attribute} debe estar entre {min} y {max}.",
      string: "{attribute} debe tener entre {min} y {max} caracteres.",
    },
    boolean: "{attribute} debe ser verdadero o falso.",
    column_visibility_always_visible: "La columna {column} siempre está visible.",
    column_visibility_missing_column: "Falta la columna {column} en la visibilidad de columnas.",
    column_visibility_unknown_column: "Columna desconocida {column}.",
    confirmed: "La confirmación de {attribute} no coincide.",
    course_content_missing_linked_appointment: "Por favor, vincula el contenido del curso con una cita.",
    course_content_missing_linked_certificate: "Por favor, crea un certificado.",
    course_content_missing_linked_cloze: "Por favor, vincula el contenido del curso con un texto con espacios.",
    course_content_missing_linked_file: "Por favor, vincula el contenido del curso con un archivo de la mediateca.",
    course_content_missing_linked_form: "Por favor, vincula el contenido del curso con un formulario.",
    course_content_missing_related_category_items: "Por favor, añade al menos una categoría.",
    course_content_missing_related_question_items: "Por favor, añade al menos una pregunta.",
    course_content_missing_related_text_items: "Por favor, añade al menos un contenido de texto.",
    course_content_missing_related_todo_items: "Por favor, indica al menos una tarea.",
    course_content_text_flip_box_missing_item_data: "Por favor, proporciona una imagen o un texto.",
    current_password: "La contraseña actual no es correcta.",
    date: "{attribute} no es una fecha válida.",
    date_equals: "{attribute} debe ser una fecha igual a {date}.",
    date_format: "{attribute} no coincide con el formato {format}.",
    different: "{attribute} y {other} deben ser diferentes.",
    digits: "{attribute} debe tener {digits} dígitos.",
    digits_between: "{attribute} debe tener entre {min} y {max} dígitos.",
    dimensions: "{attribute} tiene dimensiones de imagen incorrectas.",
    distinct: "{attribute} tiene un valor duplicado.",
    email: "{attribute} debe ser una dirección de correo válida.",
    emails: "{attribute} debe ser una lista separada por comas de correos electrónicos.",
    end_time_cannot_be_before_the_start_time: "La hora de finalización no puede ser anterior a la hora de inicio.",
    ends_with: "{attribute} debe terminar con uno de los siguientes valores: {values}.",
    exists: "El/la {attribute} seleccionado/a no es válido/a.",
    external_user_recipients: "Los reportings de usuarios solo pueden enviarse a direcciones de correo de administradores mientras los datos personales estén ocultos para usuarios externos.",
    file: "{attribute} debe ser un archivo.",
    filled: "{attribute} es obligatorio.",
    gt: {
      array: "{attribute} debe tener más de {value} elementos.",
      file: "{attribute} debe ser mayor que {value} kilobytes.",
      numeric: "{attribute} debe ser mayor que {value}.",
      string: "{attribute} debe tener más de {value} caracteres.",
    },
    gte: {
      array: "{attribute} debe tener {value} o más elementos.",
      file: "{attribute} debe ser mayor o igual a {value} kilobytes.",
      numeric: "{attribute} debe ser mayor o igual a {value}.",
      string: "{attribute} debe tener {value} caracteres o más.",
    },
    image: "{attribute} debe ser una imagen.",
    in: "El/la {attribute} seleccionado/a no es válido/a.",
    in_array: "{attribute} no existe en {other}.",
    integer: "{attribute} debe ser un número entero.",
    invalid_array_ids: "{attribute} contiene campos no válidos.",
    invalid_value_for_field: "Valor no válido para el campo {attribute}",
    ip: "{attribute} debe ser una dirección IP válida.",
    ipv4: "{attribute} debe ser una dirección IPv4 válida.",
    ipv6: "{attribute} debe ser una dirección IPv6 válida.",
    json: "{attribute} debe ser una cadena JSON válida.",
    lt: {
      array: "{attribute} debe tener menos de {value} elementos.",
      file: "{attribute} debe ser menor que {value} kilobytes.",
      numeric: "{attribute} debe ser menor que {value}.",
      string: "{attribute} debe tener menos de {value} caracteres.",
    },
    lte: {
      array: "{attribute} no debe tener más de {value} elementos.",
      file: "{attribute} debe ser menor o igual a {value} kilobytes.",
      numeric: "{attribute} debe ser menor o igual a {value}.",
      string: "{attribute} debe tener como máximo {value} caracteres.",
    },
    max: {
      array: "{attribute} no puede tener más de {max} elementos.",
      file: "{attribute} no puede ser mayor que {max} kilobytes.",
      numeric: "{attribute} no puede ser mayor que {max}.",
      string: "{attribute} no puede tener más de {max} caracteres.",
    },
    mimes: "{attribute} debe ser un archivo de tipo: {values}.",
    mimetypes: "{attribute} debe ser un archivo de tipo: {values}.",
    min: {
      array: "{attribute} debe tener al menos {min} elementos.",
      file: "{attribute} debe tener al menos {min} kilobytes.",
      numeric: "{attribute} debe ser al menos {min}.",
      string: "{attribute} debe tener al menos {min} caracteres.",
    },
    multiple_of: "{attribute} debe ser múltiplo de {value}.",
    needs_at_least_one_correct_answer: "Debe haber al menos una respuesta correcta.",
    needs_exactly_one_correct_answer: "Debe haber exactamente una respuesta correcta.",
    not_in: "El/la {attribute} seleccionado/a no es válido/a.",
    not_regex: "El formato de {attribute} no es válido.",
    numeric: "{attribute} debe ser un número.",
    password: "La contraseña es incorrecta.",
    present: "{attribute} debe estar presente.",
    prohibited: "El campo {attribute} no está permitido.",
    prohibited_if: "El campo {attribute} no está permitido cuando {other} tiene el valor {value}.",
    prohibited_unless: "El campo {attribute} no está permitido, a menos que {other} esté en {values}.",
    prohibits: "El campo {attribute} prohíbe la presencia de {other}.",
    regex: "El formato de {attribute} no es válido.",
    required: "Este campo es obligatorio.",
    required_if: "El campo {attribute} es obligatorio cuando {other} tiene el valor {value}.",
    required_unless: "El campo {attribute} es obligatorio a menos que {other} esté en {values}.",
    required_with: "El campo {attribute} es obligatorio cuando {values} está presente.",
    required_with_all: "El campo {attribute} es obligatorio cuando {values} están presentes.",
    required_without: "El campo {attribute} es obligatorio cuando {values} no está presente.",
    required_without_all: "El campo {attribute} es obligatorio cuando ninguno de los valores {values} está presente.",
    same: "El campo {attribute} y {other} deben coincidir.",
    size: {
      array: "{attribute} debe contener {size} elementos.",
      file: "{attribute} debe tener {size} kilobytes.",
      numeric: "{attribute} debe ser {size}.",
      string: "{attribute} debe tener {size} caracteres.",
    },
    starts_with: "{attribute} debe comenzar con uno de los siguientes valores: {values}.",
    string: "{attribute} debe ser texto.",
    tag_restriction: {
      must_be_array: "{attribute} debe ser una lista.",
      must_contain_at_least_one_tag: "{attribute} debe contener al menos una etiqueta.",
      tags_dont_belong_to_this_app: "Algunas de las etiquetas no son válidas.",
    },
    timezone: "{attribute} debe ser una zona horaria válida.",
    unique: "{attribute} ya ha sido utilizado.",
    uploaded: "La carga de {attribute} falló.",
    uploadedImage: "{attribute} debe ser una cadena, una lista o nulo.",
    url: "El formato de {attribute} no es válido.",
    uuid: "{attribute} debe ser un UUID válido.",
  },
}
